<div id="navigation">
  <button class="btn btn-danger" (click)="toggle()" [ngClass]="{ closed: !open }">
    <i class="fa fa-warning" *ngIf="!open"></i>
    <span class="close" *ngIf="open"></span>
    <div class="nav-tooltip">Validation issues</div>
  </button>
  <span class="filter-indicator" *ngIf="invalidQuestions?.length && !open">
    {{ invalidQuestions.length }} problem{{ invalidQuestions.length > 1 ? 's' : '' }}
  </span>
  <div *ngIf="open">
    <div class="nav-panel">
      <div class="title">
        <h3>
          Issues that need to be fixed <span style="color: #dc3e3e">({{ invalidQuestions.length }})</span>
        </h3>
      </div>
      <div class="content" *ngIf="invalidQuestions">
        <div [perfectScrollbar] style="max-height: 500px">
          <div *ngFor="let problem of invalidQuestions" (click)="goTo(problem.originalId)" class="issue-card">
            <div>
              <i class="fa fa-close"></i>
            </div>
            <div class="issue-content">
              <span class="title">{{ problem.questionText }}</span>
              <span class="description">Fix {{ problem.type }} conditional logic</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
